export { default } from './ProductInfo';
